import { Box, Container, Stack, useTheme } from "@mui/material";

import { useIsFeatureEntitled } from "../../../Context/TierProvider";
import { Faq } from "./Faq";
import { GetStarted } from "./GetStarted";
import { Overview } from "./Overview";

const interSectionSpacing = 6;
const pageWidth = 1000;

const Fsk8sUpsell = () => {
  const customerHasEntitlement = useIsFeatureEntitled("lens:eks");
  const theme = useTheme();

  return (
    <>
      <Container>
        <Box
          sx={{
            mt: interSectionSpacing,
            mb: interSectionSpacing,
            mx: "auto",
            maxWidth: pageWidth,
          }}
        >
          <Stack spacing={6}>
            <Overview />
            {customerHasEntitlement && <GetStarted />}
          </Stack>
        </Box>
      </Container>
      <Box
        sx={{
          // Undo MainLayout default padding
          mx: -2,
          mb: "-80px",
          pb: "80px",

          px: 2,
          pt: interSectionSpacing,
          background: theme.palette.general.backgroundDark,
        }}
      >
        <Box sx={{ mx: "auto", maxWidth: pageWidth }}>
          <Faq />
        </Box>
      </Box>
    </>
  );
};

export default Fsk8sUpsell;
